// Robust fallback data for Heine Design
// Contains all products, gallery items, and past ads scraped from heinedesign.com

export const FALLBACK_PRODUCTS = [
  {
    id: "15171b67-c09b-4dd2-a55e-480a6fb25c49",
    name: "CUBISME SPISEBORD / DINNING TABLE 160 x 160 x 72 cm.",
    price: "kr.54,995.00",
    active: true,
    slug: "cubism",
    product_images: [
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/l-cubisme.jpg"
    ],
    gallery: [
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/l-cubisme-300x314.jpg",
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/heine-280808-07-300x225.jpg",
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/heine-280808-05-300x234.jpg"
    ],
    short_description: "<p>“CUBISME” SPISEBORD – RUSTFRI STÅLRAMME ELLER SORT RAMME – 12 MM. GLAS HÆRDET ELLER 20 MM. ITALIENSK SKIFER. – STØRRELSE 160 x 160 x 75 cm.</p>",
    long_description: "<p>“CUBISME” DINNIG TABLE – STAINLESS STEEL FRAME OR BLACK FRAME – 12 MM. TEMPERED GLASS OR 20 MM. ITALIEN SLATE – SIZE 160 x 160 x 75 CM.</p>",
    related_products: "4-ben-dinner,pandora-sofabord-med-haerdet-glasplade-100x100x47,dobbeltdecker,basic",
    inspiration_products: "4-ben-dinner",
    sort_order: 6,
    terms: {
      "product-type": ["dining-table"],
      "product-category": ["tables"],
      "product-material": ["glass", "slate", "stainless-steel"]
    }
  },
  {
    id: "158f5dcb-eca8-40e5-9d58-1df14c15a0bb",
    name: "TWIST 2 SOFABORD / COFFE TABLE",
    price: "kr.13,995.00",
    active: true,
    slug: "twist-2-sofabord-coffe-table",
    product_images: [
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/twist-70x140-med-skif-16-12-15.jpg"
    ],
    gallery: [
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/twist-70x140-med-skif-16-12-15-300x222.jpg",
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/twist-1x1-med-skif-300x242.jpg",
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/heine-bord-2-a-300x248.jpg",
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/s-tw3.jpg",
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/l-twiststor-300x314.jpg"
    ],
    short_description: "<p>TWIST 2 SOFABORD – RUSTFRI STÅL RAMME. – MED SKIFER ELLER GRANIT ELLER MARMOR ELLER 12 HÆRDET GLAS. – STØRRELSEN 70 X 140 X 43 CM. – 100 X 100 X 43 CM.</p>",
    long_description: "<p>TWIST 2 COFFEE TABLE – STAINLESS STEEL FRAME. – WITH SLATE OR GRANIT OR MARBLE OR 12 MM. TEMPERED GLASS. – SIZES 70 X 140 X 43 CM. – 100 X 100 X 43 CM. – PRICE 1867 €</p>",
    related_products: "4-ben,dice,pandora-sofabord-med-haerdet-glasplade-100x100x47,cubism",
    inspiration_products: "twist-1-sofabord-coffee-table",
    sort_order: 21,
    terms: {
      "product-type": ["coffee-table"],
      "product-category": ["tables"],
      "product-material": ["glass", "granite", "marble", "slate", "stainless-steel"]
    }
  },
  {
    id: "17d44a62-5107-46d9-8aa1-d5a6e0035682",
    name: "FRAME PUFF / SKAMMEL / DAYBED W-100 X L-140 X H-52 CM.",
    price: "kr.19,995.00",
    active: true,
    slug: "frame-puff-skammel-daybed-w-100-x-l-140-x-h-52-cm",
    product_images: [
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/heine-0058-u-taske-hd.jpg"
    ],
    gallery: [
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/heine-0058-u-taske-hd-300x344.jpg"
    ],
    short_description: "<p>FRAME PUFF / skammel – ramme af rustfrit stål. – med læder. – kan bestrillles i størrelse. – B x L x H – 40 x 100 x 52 cm. – 40 X 140 X 52 cm. – 70 X 140 X 52 cm. – 100 X 140 x 52 cm.</p>",
    long_description: "<p>FRAME PUFF / Daybed – Frame of stainless steel. – with quality leather. – available in size – W x L x H – 40 x 100 x 52 cm. – 40 X 140 X 52 cm. – 70 X 140 X 52 cm. – 100 X 140 x 52 cm.</p>",
    related_products: "pandora-sofabord-100x100x47-cm,frame-puff-skammel-daybed-w-40-x-l-100-x-h-52-cm,frame-puff-skammel-daybed-l-140-x-w-70-x-h-52-cm,pandora-sofabord-100x100x47-cm-med-granit",
    inspiration_products: "frame-puff-skammel-daybed",
    sort_order: 10,
    terms: {
      "product-type": ["daybed"],
      "product-category": ["uncategorized"],
      "product-material": ["leather", "stainless-steel"]
    }
  },
  {
    id: "1b159a57-5936-4776-9c5d-259b6f233950",
    name: "GEKKO KNAGE / COAT HANGER",
    price: "kr.1,795.00",
    active: true,
    slug: "gekko",
    product_images: [
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/l-gekko2.jpg"
    ],
    gallery: [
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/l-gekko2-300x314.jpg",
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/l-gekko-300x314.jpg"
    ],
    short_description: "<p>“GEKKO” KNAGE – RUSTFRI STÅL – LÆNGDE 125 x 20 cm.</p>",
    long_description: "<p>“GEKKO” COAT HANGER – STAINLESS STEEL – SIZE 125 x 20 cm. – PRICE 240 €</p>",
    related_products: "vild-eg-vinreol-wild-oag-wine-rack,minibror-minibrother-spejle-mirrors,spejle-mirrors-lillebror,collector",
    inspiration_products: "basic-mini-sidebord-lamp-table",
    sort_order: 17,
    terms: {
      "product-type": ["coat-hanger"],
      "product-category": ["other-furnitures"],
      "product-material": ["stainless-steel"]
    }
  },
  {
    id: "2bd7313c-051e-40ee-8eeb-683c2e16ff91",
    name: "LILLEBROR / BABYBROTHER SPEJLE / MIRRORS 60 x 160 cm. eller / or 100 x 100 cm",
    price: "kr.4,995.00",
    active: true,
    slug: "spejle-mirrors-lillebror",
    product_images: [
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/billede-004.jpg"
    ],
    gallery: [
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/billede-004-300x450.jpg",
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/s-biglit.jpg",
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/frontp-slide-8-300x159.jpg",
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/l-biglit-300x314.jpg"
    ],
    short_description: "<p>LILLEBROR SPEJL – RUSTFRI STÅL ELLER SORT RAMME. – STØRRELSE 60 X 160 CM. ELLER 100 X 100 CM.</p>",
    long_description: "<p>LITTLEBROTHER MIRROR – STAINLESS STEEL OR BLACK FRAME. – SIZE 60 X 160 CM.OR 100 X 100 CM.</p>",
    related_products: "big-little-brother,fly-konsol-bord-console-table,dobbeltdek,vild-eg-vinreol-wild-oag-wine-rack",
    inspiration_products: "big-little-brother",
    sort_order: 15,
    terms: {
      "product-type": ["mirror"],
      "product-category": ["other-furnitures"],
      "product-material": ["stainless-steel"]
    }
  },
  {
    id: "3550d674-771e-49ba-bd6f-ba86847f3a9f",
    name: "KONGE STOL STÅL",
    price: "kr.19,995.00",
    active: true,
    slug: "konge-stol-stal",
    product_images: [
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/heined-0117.jpg"
    ],
    gallery: [
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/heined-0117-300x268.jpg"
    ],
    short_description: "<p>KONGE STOLEN UDFØRT I RUSTFRI STÅL OG LÆDER. MÅL 70X70X75 CM.</p>",
    long_description: "<p>PRODUCERES EFTER ORDRE MED ULD ELLER LÆDER.</p>",
    related_products: "frame-puff-skammel-daybed-l-140-x-w-70-x-h-52-cm,pandora-sofabord-100x100x47-cm,frame-puff-skammel-daybed-w-100-x-l-140-x-h-52-cm,frame-puff-skammel-daybed-w-40-x-l-100-x-h-52-cm",
    inspiration_products: "frame-puff-skammel-daybed",
    sort_order: 23,
    terms: {
      "product-type": ["chair"],
      "product-category": ["uncategorized"],
      "product-material": ["leather", "stainless-steel", "wool"]
    }
  },
  {
    id: "5102fe71-35a8-4082-8e05-c39fa4c2be55",
    name: "PANDORA SOFABORD MED HÆRDET GLASPLADE 100X100X47",
    price: "kr.14,995.00",
    active: true,
    slug: "pandora-sofabord-med-haerdet-glasplade-100x100x47",
    product_images: [
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/heined-square-glas.jpg"
    ],
    gallery: [
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/heined-square-glas-300x300.jpg",
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/heined-square-skifer-300x300.jpg",
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/heined-square-granit-300x300.jpg"
    ],
    short_description: "<p>PANDORA SOFABORD – RUSTFRI STÅL BOKS. – MED 12 MM. HÆRDET GLASPLADE – STØRRELSEN 100 X 100 X 47 CM.</p>",
    long_description: "<p>PANDORA COFFEE TABLE – STAINLESS STEEL CUBE. – WITH 12 MM. TOUGHENED GLASS. – SIZES 100 X 100 X 47 CM.</p>",
    related_products: "twist-1-sofabord-coffee-table,4-ben-dinner,dobbeltdek,mammut",
    inspiration_products: "basic",
    sort_order: 16,
    terms: {
      "product-type": ["coffee-table"],
      "product-category": ["tables"],
      "product-material": ["glass", "stainless-steel"]
    }
  },
  {
    id: "59d55931-0a2f-4d38-8ece-0ba63b450a11",
    name: "DICE SIDEBORD SOFABORD / COFFEE TABLE",
    price: "kr.3,995.00",
    active: true,
    slug: "dice",
    product_images: [
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/l-dice2.jpg"
    ],
    gallery: [
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/l-dice2-300x314.jpg",
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/l-dice1-300x314.jpg",
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/heini-20140221-01b-300x300.jpg"
    ],
    short_description: "<p>DICE SIDE / LAMPE / NAT / SOFABORD – RUSTFRI STÅL RAMME. – 12 MM. HÆRDET GLAS. – STØRRELSE 50 x 50 x 52 cm</p>",
    long_description: "<p>DICE SIDE / LAMP / BED/ COFFEE TABLE – STAINLEES STEEL FRAME. – 12 MM. TEMPERED GLASS. – Size 50 x 50 x 52 CM. – PRICE 533 €</p>",
    "related_products": "flyer,basic-mini-sidebord-lamp-table,mammut,4-ben",
    "inspiration_products": "basic-mini-sidebord-lamp-table",
    "sort_order": 4,
    terms: {
      "product-type": ["coffee-table", "side-table"],
      "product-category": ["tables"],
      "product-material": ["glass", "stainless-steel"]
    }
  },
  {
    id: "5a21adac-833c-481e-b28a-034b1c55b02f",
    name: "KVADRAT SOFA  / DAYBED",
    price: "kr.67,500.00",
    active: true,
    slug: "kvadrat-sofa",
    product_images: [
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/l-kvadrat.jpg"
    ],
    gallery: [
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/l-kvadrat-300x314.jpg",
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/heine-290208-03-300x400.jpg",
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/heine-290208-04-300x400.jpg",
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/firkantsofa-heine-300x318.jpg",
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/billede-008-300x359.jpg",
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/s-kvadrat.jpg"
    ],
    short_description: "<p>“KVADRAT” SOFA – RUSTFRI STÅLRAMME – LEVERES I STØRRELSEN 160 X 160 CM – TOTALHØJDE 65 CM. – LEVERES I LÆDER ELLER ULD</p>",
    long_description: "<p>“KVADRAT” SOFA – STAINLESS STELL FRAME – SIZE 160 X 160 CM – HEIGHT 65 CM. – COVERED WITH LEATHER OR WOOL.</p>",
    "related_products": "frame-puff-skammel-daybed",
    "inspiration_products": "frame-puff-skammel-daybed",
    "sort_order": 19,
    terms: {
      "product-type": ["daybed"],
      "product-category": ["sofas-seatings"],
      "product-material": ["leather", "stainless-steel", "wool"]
    }
  },
  {
    id: "5cf6ebc3-80b7-44c0-8c23-474a8ce8b413",
    name: "DD2 SOFABORD / COFFEE TABLE EGETRÆ 70 x 140 x 46 cm.",
    price: "kr.13,995.00",
    active: true,
    slug: "dobbeltdek",
    product_images: [
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/s-dob1.jpg"
    ],
    gallery: [
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/s-dob1.jpg",
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/l-dobbeltdek-300x314.jpg"
    ],
    short_description: "<p>DD2 SOFABORD – RUSTFRI STÅL RAMMER. – LAKERET PLADE ELLER MASSIV TRÆ. ( EGE / BILLED ) – 12 MM. HÆRDET GLAS. – B x L x H – STØRRELSE 70 X 140 CM X HØJDE: 46 cm</p>",
    long_description: "<p>DD2 COFFEE TABLE – STAINLESS STEEL FRAMES. – PAINTED PLATE OR ANY WOODTYPE. ( OAK / PICTURE ) – 12 MM TEMPERED GLASS. – W x L x H – SIZES: 70 X 140 CM HEIGHT: 46 CM.</p>",
    "related_products": "4-ben,cubism,basic,mellembror-mediumbrother-spejle-mirrors",
    "inspiration_products": "dobbeltdecker",
    "sort_order": 7,
    terms: {
      "product-type": ["coffee-table"],
      "product-category": ["other-furnitures", "tables"],
      "product-material": ["glass", "oak", "stainless-steel"]
    }
  },
  {
    id: "60f00c64-6fb3-4f13-bcc7-52d9a2c8f65c",
    name: "VILD EG VINREOL / WILD OAK WINE RACK",
    price: "kr.7,950.00",
    active: true,
    slug: "vild-eg-vinreol-wild-oag-wine-rack",
    product_images: [
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/heine-vin-hd1.jpg"
    ],
    gallery: [
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/heine-vin-hd1-300x396.jpg",
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/frontp-slide-7-300x159.jpg"
    ],
    short_description: "<p>VILD EG VINREOL – DANSK EGETRÆ. – MED SORT LAKERET STÅLFOD. – VARRIERE AF ANTAL AF HULLER Ø 32 MM. – VÆGT 50 KG. HØJDE 140-160 CM</p>",
    long_description: "<p>WILD OAK WINE RACK – DAINISH OAK. – BLACK STEEL FOOT. – AROUND 30 HOLES DIA 32 MM. – WEIGHT 50 KG. HIGH APROX. 140-160 CM.</p>",
    "related_products": "collector,spejle-mirrors-lillebror,frame-puff-skammel-daybed,big-little-brother",
    "inspiration_products": "collector",
    "sort_order": 18,
    terms: {
      "product-type": ["wine-rack"],
      "product-category": ["other-furnitures"],
      "product-material": ["oak", "stainless-steel"]
    }
  },
  {
    id: "683ef48c-0099-4cbc-be03-206fe5fd9c70",
    name: "FRAME SOFABORD / COFFEE TABLE 100 x100 x 43 eller / or 70 x 140 x 43 cm.",
    price: "kr.15,995.00",
    active: true,
    slug: "frame-sofabord-coffee-table",
    product_images: [
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/heine-280808-03.jpg"
    ],
    gallery: [
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/heine-280808-03-300x225.jpg",
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/heine-bord-4-b-300x236.jpg",
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/billede-005-300x193.jpg",
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/s-kva1.jpg",
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/s-kva4.jpg"
    ],
    short_description: "<p>FRAME SOFABORD – RUSTFRI STÅL RAMME. – MED SKIFER ELLER GRANIT ELLER MARMOR ELLER 12 HÆRDET GLAS. – STØRRELSEN 70 X 140 X 43 CM. – 100 X 100 X 43 CM.</p>",
    long_description: "<p>FRAME COFFEE TABLE – STAINLESS STEEL FRAME. – WITH SLATE OR GRANIT OR MARBLE OR 12 MM. TEMPERED GLASS. – SIZES 70 X 140 X 43 CM. – 100 X 100 X 43 CM.</p>",
    "related_products": "dobbeltdecker,dice,cubism,konsol",
    "inspiration_products": "4-ben",
    "sort_order": 21,
    terms: {
      "product-type": ["coffee-table"],
      "product-category": ["tables"],
      "product-material": ["glass", "granite", "marble", "slate", "stainless-steel"]
    }
  },
  {
    id: "6c89c517-4d66-46f3-a947-8d387a02ca8c",
    name: "STOREBROR / BIGBROTHER SPEJLE / MIRRORS 100 x 200 cm.",
    price: "kr.8,995.00",
    active: true,
    slug: "big-little-brother",
    product_images: [
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/billede-004.jpg"
    ],
    gallery: [
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/billede-004-300x450.jpg",
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/l-biglit-300x314_1.jpg",
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/billede-003-300x462.jpg",
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/frontp-slide-8-300x159.jpg"
    ],
    short_description: "<p>STOREBROR SPEJL – RUSTFRI STÅL ELLER SORT RAMME. – STOREBROR 100 X 200 CM. – STØRRE MÅL – MAIL ELLER RING EFTER PRIS. – MAX STØRRELSE 400 X 600 CM.</p>",
    long_description: "<p>BIGBROTHER MIRROR – STAINLESS STEEL OR BLACK FRAME. – SIZE 100 X 200 CM. – LARGER SIZE – MAIL OR PHONE FOR PRICE. – MAX SIZE 400 X 600 CM.</p>",
    "related_products": "frame-puff-skammel-daybed,collector,basic-mini-sidebord-lamp-table,minibror-minibrother-spejle-mirrors",
    "inspiration_products": "spejle-mirrors-lillebror",
    "sort_order": 13,
    terms: {
      "product-type": ["mirror"],
      "product-category": ["other-furnitures"],
      "product-material": ["stainless-steel"]
    }
  },
  {
    id: "78807b11-7ce7-4438-b8f5-20a0d9dba841",
    name: "BASIC 2 SOFA BORD / COFFEE TABLE",
    price: "kr.14,995.00",
    active: true,
    slug: "basic",
    product_images: [
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/heini-20140221-06d.jpg"
    ],
    gallery: [
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/heini-20140221-06d-300x281.jpg",
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/heini-20140221-det-03-300x223.jpg",
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/heini-20140221-06a-300x288.jpg",
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/heini-20140221-det-01-300x225.jpg",
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/heini-20140221-06c-300x281.jpg",
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/heini-20140221-06b-300x291.jpg",
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/heini-20140221-04b-300x272.jpg",
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/heini-20140221-04a-300x278.jpg",
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/heini-20140221-01b-300x300.jpg"
    ],
    short_description: "<p>BASIC 2 SOFABORD – RUSTFRI STÅLSTEL. – 6 MM. KERAMISK PLADE I SORT ELLER HVID ELLER MED 12 MM. HÆRDET GLAS – LEVERES I STØRRELSEN 70 X 140 CM. & 100 X 100 CM. – TOTALHØJDE 51 CM. MED GLAS 52 CM.</p>",
    long_description: "<p>BASIC 2 COFFEE TABLE – STAINLESS STEEL CONSTRUCTION – 6 MM. CERAMIC PLATE IN WHITE OR BLACK OR WITH 12 MM. TEMPERED GLASS – SIZE 70 X 140 CM. & 100 X 100 CM. – HEIGHT 51 CM./ WITH GLASS 52 CM.</p>",
    related_products: "4-ben-dinner,dobbeltdek,cubism,pandora-sofabord-med-haerdet-glasplade-100x100x47",
    "inspiration_products": "spejle-mirrors-lillebror,big-little-brother",
    "sort_order": 1,
    terms: {
      "product-type": ["coffee-table"],
      "product-category": ["tables"],
      "product-material": ["glass", "slate", "stainless-steel"]
    }
  },
  {
    id: "91991961-4347-433e-9698-61875ee4c610",
    name: "FRAME SOFABORD GLAS / COFFEE TABLE GLASS",
    price: "kr.9,995.00",
    active: true,
    slug: "4-ben",
    product_images: [
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/l-4-ben.jpg"
    ],
    gallery: [
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/l-4-ben-300x314.jpg"
    ],
    short_description: "<p>FRAME SOFABORD – RUSTFRI STÅLBEN. – 12 MM. FACÈTSLEBET GLASPLADE. – I STR. 70 X 140 CM. + 100 x 100 CM. – TOTALHØJDE 43 CM.</p>",
    long_description: "<p>FRAME COFFEE TABLE – STAINLESS STEEL CONSTRUCTION – 12 MM. FACÈTCUT GLASPLATE – SIZE 70 X 140 CM. + 100 x 100 CM. – HEIGHT 43 CM. – PRICE FROM 1333 €</p>",
    related_products: "frame-sofabord-coffee-table,basic-mini-sidebord-lamp-table,twist-1-sofabord-coffee-table,twist-2-sofabord-coffe-table",
    "inspiration_products": "4-ben-dinner",
    "sort_order": 22,
    terms: {
      "product-type": ["coffee-table"],
      "product-category": ["tables"],
      "product-material": ["glass", "stainless-steel"]
    }
  },
  {
    id: "ad3fb3ce-c379-40cb-b983-6d8160fcfc42",
    name: "DD1 SOFABORD / COFFEE TABLE",
    price: "kr.9,995.00",
    active: true,
    slug: "dobbeltdecker",
    product_images: [
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/l-dd.jpg"
    ],
    gallery: [
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/l-dd-300x314.jpg",
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/s-dob1-100x100.jpg",
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/l-dobbeltdek-300x314.jpg"
    ],
    short_description: "<p>DD 1 SOFABORD – RUSTFRI STÅL RAMMER. – LAKERET PLADE ELLER MASSIV TRÆ ( EGE / BILLED ) – 12 MM. HÆRDET GLAS. – STØRRELSE 40 X 140 CM X HØJDE: 46 cm.</p>",
    long_description: "<p>DD 1 COFFEE TABLE – STAINLESS STEEL FRAMES. – PAINTED PLATE OR ANY WOODTYPE ( OAK / PICTURE ) – 12 MM TEMPERED GLASS. – SIZES: 40 X 140 CM HEIGHT: 46 CM.</p>",
    related_products: "dobbeltdek,basic-mini-sidebord-lamp-table,fly-konsol-bord-console-table,mammut",
    "inspiration_products": "dobbeltdek",
    "sort_order": 9,
    terms: {
      "product-type": ["coffee-table"],
      "product-category": ["tables"],
      "product-material": ["glass", "oak", "stainless-steel"]
    }
  },
  {
    id: "b60f29f2-e3c4-478d-b361-295a5389ed55",
    name: "FRAME SPISEBORD / DINNER TABLE",
    price: "kr.19,995.00",
    active: true,
    slug: "4-ben-dinner",
    product_images: [
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/l-4ben-dinner.jpg"
    ],
    gallery: [
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/l-4ben-dinner-300x314.jpg",
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/l-4ben-dinner-100x100.jpg"
    ],
    short_description: "<p>“4-BEN” SPISEBORD / SKRIVEBORD – Rustfri stålramme. – Glasplade 12 mm. facetslebet. – Størrelser 100 x 200 cm. / 70 X 140 cm. – Total højde: 73 cm.</p>",
    long_description: "<p>“4-BEN” DINNING TABLE / OFFICE TABLE – STAINLESS STEEL FRAME – 12 MM. FACÈTCUT GLASPLATE – SIZES 100 x 200 CM. & 70 X 140 CM. – HEIGHT: 73 CM</p>",
    related_products: "dobbeltdecker,basic-mini-sidebord-lamp-table,fly-konsol-bord-console-table,mammut",
    "inspiration_products": "cubism",
    "sort_order": 14,
    terms: {
      "product-type": ["dining-table"],
      "product-category": ["tables"],
      "product-material": ["glass", "stainless-steel"]
    }
  },
  {
    id: "cc9ac74b-b993-4af0-8927-f34302e370d6",
    name: "FRAME HD1- KONSOL / CONSOLE W-40 x L-140 x H-72 cm.",
    price: "kr.12,995.00",
    active: true,
    slug: "konsol",
    product_images: [
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/l-konsol.jpg"
    ],
    gallery: [
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/l-konsol-300x314.jpg",
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/heini-20140221-02c-300x260.jpg",
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/heini-20140221-02a-300x300.jpg",
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/img-2147-scaled-300x225.jpg",
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/s-konsol2.jpg",
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/s-konsol.jpg"
    ],
    short_description: "<p>FRAME HD1 KONSOLBORD – RUSTFRI STÅLRAMME. – 12 MM. HÆRDET GLASPLADE – STØRRELSEN : – B x L x H – 40 X 72 X 140 CM. – 40 X 102 X 100 CM. – 40 X 102 X 140 CM. – TOTALHØJDE 72 ELLER 102 CM.</p>",
    long_description: "<p>FRAME HD1 CONSOLE TABLE – STAINLESS STEEL FRAME – 12 MM. TEMPERED GLASS – SIZE : – W x L x H – 40 X 72 X 140 CM. – 40 X 102 X 100 CM. – 40 X 102 X 140 CM. – HEIGHT 72 OR 102 CM.</p>",
    related_products: "dobbeltdek,pandora-sofabord-med-haerdet-glasplade-100x100x47,4-ben,cubism",
    "inspiration_products": "vild-eg-vinreol-wild-oag-wine-rack",
    "sort_order": 12,
    terms: {
      "product-type": ["console-table"],
      "product-category": ["tables"],
      "product-material": ["glass", "stainless-steel"]
    }
  },
  {
    id: "cda2db51-13b3-4b67-a43c-262eb0f36ec1",
    name: "COLLECTOR VINREOL / WINE RACK",
    price: "kr.4,995.00",
    active: true,
    slug: "collector",
    product_images: [
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/l-collector.jpg"
    ],
    gallery: [
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/l-collector-300x314.jpg",
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/l-vin-300x314.jpg",
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/frontp-slide-7-300x159.jpg"
    ],
    short_description: "<p>COLLECTOR VINREOL – SORT LAKERET MDF PLADE – STÅLRAMME – 48 HOLDERE KUN TIL BORDEAUX FLASKE STØRRELSE – LEVERES I STØRRELSEN 40 X 200 CM.</p>",
    long_description: "<p>COLLECTOR WINE RACK – BLACK WOODEN CLEAR COATED – STAINLESS STEEL FRAME – 48 SOCKETS FOR BORDEAUX BOTTLE SIZE ONLY – SIZE: 40 X 200 CM. – PRICE 666 €</p>",
    related_products: "basic-mini-sidebord-lamp-table,minibror-minibrother-spejle-mirrors,spejle-mirrors-lillebror,mellembror-mediumbrother-spejle-mirrors",
    "inspiration_products": "vild-eg-vinreol-wild-oag-wine-rack",
    "sort_order": 2,
    terms: {
      "product-type": ["wine-rack"],
      "product-category": ["other-furnitures"],
      "product-material": ["oak", "stainless-steel"]
    }
  },
  {
    id: "cde98ab5-12f9-4c5d-8a88-36fbc694b0a4",
    name: "BASIC MINI SIDEBORD / LAMP TABLE",
    price: "kr.4,995.00",
    active: true,
    slug: "basic-mini-sidebord-lamp-table",
    product_images: [
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/heini-20140221-01a.jpg"
    ],
    gallery: [
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/heini-20140221-01a-300x300.jpg",
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/heini-20140221-01b-300x300.jpg",
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/heini-20140221-det-03-300x223_1.jpg",
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/heini-20140221-06c-300x300.jpg"
    ],
    short_description: "<p>BASIC MINI SIDE / LAMPE / NAT / SOFABORD – RUSTFRI STÅL RAMME. – 12 MM. HÆRDET GLAS. Mål: 50 x 50 x 52 cm</p>",
    long_description: "<p>BASIC MINI SIDE / LAMP / BED / COFFEE TABLE – STAINLEES STEEL FRAME. – 12 MM. TEMPERED GLASS. – Size 50 x 50 x 52 CM. – PRICE 666 €</p>",
    related_products: "mammut,pandora-sofabord-med-haerdet-glasplade-100x100x47,gekko,cubism",
    "inspiration_products": "dice,basic",
    "sort_order": 3,
    terms: {
      "product-type": ["coffee-table", "side-table"],
      "product-category": ["other-furnitures", "tables"],
      "product-material": ["glass", "stainless-steel"]
    }
  },
  {
    id: "de5504dd-628c-4192-94e6-847e44e1be08",
    name: "FLY KONSOL BORD / CONSOLE TABLE",
    price: "kr.12,995.00",
    active: true,
    slug: "fly-konsol-bord-console-table",
    product_images: [
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/heini-20140221-03d1.jpg"
    ],
    gallery: [
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/heini-20140221-03d1-300x300.jpg",
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/heini-20140221-03c-300x300.jpg",
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/heini-20140221-03b-300x300.jpg",
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/heini-20140221-03a-300x300.jpg"
    ],
    short_description: "<p>FLYER KONSOL BORD – RUSTFRI STÅL STEL. – 20 MM SKIFER ELLER 12 MM. HÆRDET GLAS. – STØRRELSE 40 X 140 X 73 CM.</p>",
    long_description: "<p>FLYER KONSOLE TABLE – STAINLESS STEEL FRAME. – 20 MM SLATE PLATE OR 12 MM. TEMPERED GLASS. – SIZE: 40 X 140 X 73 CM.</p>",
    related_products: "big-little-brother,4-ben,dice,frame-sofabord-coffee-table",
    "inspiration_products": "vild-eg-vinreol-wild-oag-wine-rack",
    "sort_order": 8,
    terms: {
      "product-type": ["console-table"],
      "product-category": ["other-furnitures", "tables"],
      "product-material": ["glass", "slate", "stainless-steel"]
    }
  },
  {
    id: "e2d33bae-1055-4e7b-a063-2a6756a4e42e",
    name: "FLYER SOFABORD / COFFEE TABLE",
    price: "kr.16,995.00",
    active: true,
    slug: "flyer",
    product_images: [
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/l-kvadrat2.jpg"
    ],
    gallery: [
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/l-kvadrat2-300x216.jpg",
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/heini-20140221-05b-300x295.jpg",
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/s-flyer3.jpg",
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/l-flyer-300x314.jpg",
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/heini-20140221-05a-300x277.jpg"
    ],
    short_description: "<p>FLYER SOFABORD – RUSTFRI STÅL STEL. – 20 MM SKIFER ELLER 12 MM. HÆRDET GLAS. – LEVERES I STØRRELSEN: – STØRRELSE 100 X 100 X 43 CM. ELLER 70 X 140 X 43 CM.</p>",
    long_description: "<p>FLYER COFFEE TABLE – STAINLESS STEEL FRAME. – 20 MM SLATE PLATE OR 12 MM. TEMPERED GLASS. – SIZE: 100 X 100 X 43 CM.OR 70 X 140 X 43 CM.</p>",
    related_products: "twist-1-sofabord-coffee-table,cubism,dice,frame-sofabord-coffee-table",
    "inspiration_products": "twist-1-sofabord-coffee-table",
    "sort_order": 5,
    terms: {
      "product-type": ["coffee-table"],
      "product-category": ["tables"],
      "product-material": ["glass", "slate", "stainless-steel"]
    }
  },
  {
    id: "fd1e988a-2370-470b-9696-7502514a5f65",
    name: "FRAME PUFF / SKAMMEL / DAYBED  W-40 x L-140 x H-52 cm.",
    price: "kr.13,995.00",
    active: true,
    slug: "frame-puff-skammel-daybed",
    product_images: [
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/heine-0058-m-taske-hd1.jpg"
    ],
    gallery: [
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/heine-0058-m-taske-hd1-300x344.jpg",
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/heine-benchx3-hd1-300x344.jpg",
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/heine-0058-u-taske-hd1-300x344.jpg",
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/heine-2-bench-hd-300x225.jpg"
    ],
    short_description: "<p>FRAME PUFF / skammel – ramme af rustfrit stål. – med læder. – kan bestrillles i størrelse. – B x L x H – 40 x 100 x 52 cm. – 40 X 140 X 52 cm. – 70 X 140 X 52 cm. – 100 X 140 x 52 cm.</p>",
    long_description: "<p>FRAME PUFF / Daybed – Frame of stainless steel. – with quality leather. – available in size – W x L x H – 40 x 100 x 52 cm. – 40 X 140 X 52 cm. – 70 X 140 X 52 cm. – 100 X 140 X 52 cm.</p>",
    related_products: "dobbeltdek,gekko,kvadrat-sofa,big-little-brother",
    "inspiration_products": "kvadrat-sofa",
    "sort_order": 11,
    terms: {
      "product-type": ["daybed"],
      "product-category": ["other-furnitures", "sofas-seatings"],
      "product-material": ["leather", "stainless-steel"]
    }
  },
  {
    id: "ff74cb4a-495c-4bb8-9bf5-19e21fef648e",
    name: "TWIST 1 SOFABORD / COFFEE TABLE",
    price: "kr.8,995.00",
    active: true,
    slug: "twist-1-sofabord-coffee-table",
    product_images: [
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/twistlille-16-12-12.jpg"
    ],
    gallery: [
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/twistlille-16-12-12-300x158.jpg",
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/twist-70x140-med-skif-300x222.jpg",
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/twist-40x140-med-kompo-16-12-15-300x248.jpg",
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/twist-70x140-med-kompo-16-12-15-300x248.jpg",
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/twist-70x140-m-kompo-16-12-15-300x248.jpg",
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/twiststor-16-12-12-300x148.jpg",
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/heine-230209-03-300x242.jpg",
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/heine-230209-04-300x222.jpg",
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/l-minitwist-300x314.jpg"
    ],
    short_description: "<p>TWIST 1 SOFABORD – RUSTFRI STÅL RAMME. – MED SKIFER ELLER GRANIT ELLER MARMOR ELLER 12 HÆRDET GLAS. – STØRRELSEN 40 X 140 X 43 CM.</p>",
    long_description: "<p>TWIST 1 COFFEE TABLE – STAINLESS STEEL FRAME. – WITH SLATE OR GRANIT OR MARBLE OR 12 MM. TEMPERED GLASS. – SIZES 40 X 140 X 43 CM. – PRICE 1200 €</p>",
    related_products: "pandora-sofabord-med-haerdet-glasplade-100x100x47,frame-sofabord-coffee-table,4-ben,basic",
    "inspiration_products": "twist-2-sofabord-coffe-table",
    "sort_order": 20,
    terms: {
      "product-type": ["coffee-table"],
      "product-category": ["tables"],
      "product-material": ["glass", "granite", "marble", "slate", "stainless-steel"]
    }
  }
];

export const FALLBACK_GALLERIES = [
  {
    id: "01a54a17-df56-4286-a58f-349babd740c5",
    title: "Værksted & Håndværk",
    slug: "vaerksted-haandvaerk",
    category: "Håndværk",
    description: "<p>Billeder fra vores værksted, der viser processen bag det ægte danske håndværk.</p>",
    images: [
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/heine-280808-03.jpg",
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/heini-20140221-03d1.jpg",
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/img-2147-scaled.jpg",
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/heine-2-bench-hd1.jpg"
    ]
  },
  {
    id: "ba41d203-1ea9-408b-a532-b26b6b31f98e",
    title: "Møbelgalleri",
    slug: "moebelgalleri",
    category: "Møbler",
    description: "<p>Eksklusivt udvalg af vores håndlavede danske designmøbler.</p>",
    images: [
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/heined-0117.jpg",
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/l-cubisme.jpg",
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/l-kvadrat.jpg",
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/heine-vin-hd1.jpg",
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/twist-70x140-med-skif-16-12-15.jpg"
    ]
  }
];

export const FALLBACK_ADS = [
  {
    id: "3162810c-d6f0-4407-806c-573d3dfa6cd9",
    title: "Heine Design Annonce 2015",
    slug: "annonce-2015",
    year: "2015",
    sort_order: 2,
    description: "<p>Præsentation af vores eksklusive vinreoler og sofaborde i rustfrit stål og italiensk skifer.</p>",
    image: [
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/frontp-slide-7-300x159.jpg"
    ]
  },
  {
    id: "c1eed395-5124-458e-95be-4fe8caf64214",
    title: "Heine Design Annonce 2016",
    slug: "annonce-2016",
    year: "2016",
    sort_order: 3,
    description: "<p>Annonce med fokus på vores klassiske Cubisme spisebord og Konge stolen i rustfrit stål og læder.</p>",
    image: [
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/dfd-300x174.png"
    ]
  },
  {
    id: "cfffc234-e913-48c0-b9db-af4573ea9a51",
    title: "Heine Design Annonce 2014",
    slug: "annonce-2014",
    year: "2014",
    sort_order: 1,
    description: "<p>Heine Design annonce i førende danske boligmagasiner, der fremviser vores minimalistiske stålmøbler og tidløse sofaborde.</p>",
    image: [
      "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/frontp-slide-8-300x159.jpg"
    ]
  }
];
